import NewReleaseNoData from './new-release-no-data';

export * from './new-release-no-data';
export default NewReleaseNoData;
